import React from 'react'
import { DateTime } from 'luxon'
import makeStyles from '@mui/styles/makeStyles'
import { FormControl, Select, MenuItem } from '@mui/material'
import { CalendarToday } from '@mui/icons-material'
import { CoachAvailabilityDay } from './useCoachAvailabilityDays'

interface CoachAvailabilityDateSelectionProps {
  days: CoachAvailabilityDay[]
  selectedDayId: string | null
  onDaySelection: (dayId: string) => void
}

const BookingDateSelection = ({ days, selectedDayId, onDaySelection }: CoachAvailabilityDateSelectionProps) => {
  const styles = useStyles()
  return (
    <div className={styles.container}>
      <FormControl>
        <Select
          value={selectedDayId || ''}
          onChange={(e) => onDaySelection(e.target.value)}
          sx={{
            fontSize: '14px',
            borderRadius: (theme) => theme.spacing(1),
            minWidth: '40%',
            '& .MuiSelect-select': {
              paddingTop: '8px',
              paddingBottom: '8px',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'text.primary',
              borderWidth: '1px',
            },
          }}
        >
          {days.map((day) => (
            <MenuItem key={day.dayId} value={day.dayId} disabled={day.slots.length === 0}>
              <div className={styles.calendarItem}>
                <CalendarToday color="primary" />
                <span className={styles.calendarText}>{DateTime.fromISO(day.dayId).toFormat('EEE, MMM d, yyyy')}</span>
              </div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

const useStyles = makeStyles({
  container: {
    position: 'relative',
    flex: 1,
    overflowX: 'hidden',
  },
  calendarItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '0.5rem',
    fontSize: '14px',
  },
  calendarText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export default BookingDateSelection
